<div class="one" fxLayout="column" [formGroup]="WillEstateForm">
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.DATEOFWILL),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DATEOFWILL),
      }"
    >
      <mat-label>Date of Will</mat-label>
      <input
        (dateInput)="CommanDatePickerEvent('input', $event, 'DATEOFWILL')"
        formControlName="DATEOFWILLTEXT"
        (dateChange)="CommanDatePickerEvent('change', $event, 'DATEOFWILL')"
        matInput
        name="DateofWill"
        [matDatepicker]="DateofWill"
        matTooltip="{{ toolTipList ? toolTipList.DATEOFWILL?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      <mat-datepicker-toggle matSuffix [for]="DateofWill"></mat-datepicker-toggle>
      <mat-datepicker #DateofWill></mat-datepicker>
      @if (testBool && toolTipList.DATEOFWILL) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.DATEOFWILL.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.DATEOFWILL?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="34"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.PAGESINWILL),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PAGESINWILL),
      }"
    >
      <mat-label>Pages in Will</mat-label>
      <input
        matInput
        formControlName="PAGESINWILL"
        matTooltip="{{ toolTipList ? toolTipList.PAGESINWILL?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      @if (testBool && toolTipList.PAGESINWILL) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.PAGESINWILL.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.PAGESINWILL?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.NAMEINWILL),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.NAMEINWILL),
      }"
    >
      <mat-label>Name in Will</mat-label>
      <input
        matInput
        formControlName="NAMEINWILL"
        matTooltip="{{ toolTipList ? toolTipList.NAMEINWILL?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      @if (testBool && toolTipList.NAMEINWILL) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.NAMEINWILL.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.NAMEINWILL?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-checkbox fxFlex="100" formControlName="MARRIEDAFTERWILL">Married after Will?</mat-checkbox>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="100"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.MARRIEDAFTERWILLTOWHOM),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.MARRIEDAFTERWILLTOWHOM),
      }"
    >
      <mat-label>To Whom</mat-label>
      <input
        matInput
        formControlName="MARRIEDAFTERWILLTOWHOM"
        matTooltip="{{ toolTipList ? toolTipList.MARRIEDAFTERWILLTOWHOM?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      @if (testBool && toolTipList.MARRIEDAFTERWILLTOWHOM) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.MARRIEDAFTERWILLTOWHOM.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.MARRIEDAFTERWILLTOWHOM?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.DATEOFMARRIAGEAFTERWILL),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DATEOFMARRIAGEAFTERWILL),
      }"
    >
      <mat-label>Date Of Marriage</mat-label>
      <input
        (dateInput)="CommanDatePickerEvent('input', $event, 'DATEOFMARRIAGEAFTERWILL')"
        formControlName="DATEOFMARRIAGEAFTERWILLTEXT"
        (dateChange)="CommanDatePickerEvent('change', $event, 'DATEOFMARRIAGEAFTERWILL')"
        matInput
        name="DateOfMarriage"
        [matDatepicker]="DateOfMarriage"
        matTooltip="{{ toolTipList ? toolTipList.DATEOFMARRIAGEAFTERWILL?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      <mat-datepicker-toggle matSuffix [for]="DateOfMarriage"></mat-datepicker-toggle>
      <mat-datepicker #DateOfMarriage></mat-datepicker>
      @if (testBool && toolTipList.DATEOFMARRIAGEAFTERWILL) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.DATEOFMARRIAGEAFTERWILL.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.DATEOFMARRIAGEAFTERWILL?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="34"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.NUMBEROFCODICILS),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.NUMBEROFCODICILS),
      }"
    >
      <mat-label># of Codicils</mat-label>
      <input
        matInput
        formControlName="NUMBEROFCODICILS"
        matTooltip="{{ toolTipList ? toolTipList.NUMBEROFCODICILS?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      @if (testBool && toolTipList.NUMBEROFCODICILS) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.NUMBEROFCODICILS.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.NUMBEROFCODICILS?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.DATEOFCODICILS),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DATEOFCODICILS),
      }"
    >
      <mat-label>Date/s of Codicil/s</mat-label>
      <input
        matInput
        formControlName="DATEOFCODICILS"
        matTooltip="{{ toolTipList ? toolTipList.DATEOFCODICILS?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      @if (testBool && toolTipList.DATEOFCODICILS) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.DATEOFCODICILS.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.DATEOFCODICILS?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.WITNESS1TOCODICIL),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.WITNESS1TOCODICIL),
      }"
    >
      <mat-label>Witness 1</mat-label>
      <input
        matInput
        formControlName="WITNESS1TOCODICIL"
        matTooltip="{{ toolTipList ? toolTipList.WITNESS1TOCODICIL?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      @if (testBool && toolTipList.WITNESS1TOCODICIL) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.WITNESS1TOCODICIL.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.WITNESS1TOCODICIL?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.WITNESS2TOCODICIL),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.WITNESS2TOCODICIL),
      }"
    >
      <mat-label>Witness 2</mat-label>
      <input
        matInput
        formControlName="WITNESS2TOCODICIL"
        matTooltip="{{ toolTipList ? toolTipList.WITNESS2TOCODICIL?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      @if (testBool && toolTipList.WITNESS2TOCODICIL) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.WITNESS2TOCODICIL.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.WITNESS2TOCODICIL?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
</div>
